import { type ChangeEvent, useCallback } from 'react';
import type { Lens } from '@hookform/lenses';
import { useController } from 'react-hook-form';
import { TextAreaInput, type TextAreaInputProps } from '@interxfi/design-system/components/input/text-area-input/text-area-input';

interface PropsWithLens extends Omit<TextAreaInputProps, 'name' | 'value'> {
  shouldUnregister?: boolean;
  lens: Lens<string>;
}

export function AppTextAreaInputWithLens({ onChange, shouldUnregister, lens, ...props }: PropsWithLens) {
  const { field, fieldState } = useController({ shouldUnregister, ...lens.interop() });
  const { onChange: fieldOnChange } = field;
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      fieldOnChange(e.target.value);
      onChange?.(e);
    },
    [onChange, fieldOnChange],
  );

  return (
    <TextAreaInput
      {...props}
      {...field}
      error={fieldState.error?.message}
      onChange={handleChange}
      touched={fieldState.isTouched}
      value={field.value || ''}
    />
  );
}
